import script from "./TressAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressAlert.vue?vue&type=script&setup=true&lang=ts"

import "./TressAlert.vue?vue&type=style&index=0&id=c25d35ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c25d35ba"]])

export default __exports__